import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
 
  const [notification, setNotification] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [wishItems, setWishItems] = useState([]);
  const [selectedWishlistItems, setSelectedWishlistItems] = useState([]);
  const [shippingAddressData, setShippingAddressData] = useState({});
  const [billingAddressData, setBillingAddressData] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [guest_product, setGuest_product] = useState(JSON.parse(localStorage.getItem("guest_products")) || []);
  const selectedCountry = Cookies.get("country");
  
  const [user, setUser] = useState(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    return storedUser || { firstname: "", lastname: "", email: "",shopname:'' };
  });

  const setUserData = (userData) => {
    setUser(userData);
  };
  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(user));
  }, [user]);

  
  const addToCart = (product, from, quantity = 1) => {
    const isProductInCart = cartItems.some(item => item.product_id === product.product_id);
    const userProduct = product.seller_id.toString() === localStorage.getItem('user-token');
  
    if (isProductInCart) {
      setNotification({message:'Product already exists in the cart' , type: 'error'});
      setTimeout(() => setNotification(null), 3000);
    } else if (userProduct) {
      setNotification({ message:"You are the seller of this product" , type:"error"});
      setTimeout(() => setNotification(null), 3000);
    } else {
      const productWithQuantity = { ...product, quantity: quantity };
      axios
        .post(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/addcart`, { product: productWithQuantity, from })
        .then((response) => {
          setCartItems((prevItems) => [...prevItems, productWithQuantity]);
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
        });
      setNotification({ message:"Product added to cart" , type: 'success'});
      setTimeout(() => setNotification(null), 3000);
      window.location.reload(false);
    }
  };
  
  const removeFromCart = (productId) => {
    if(isLoggedIn){
    axios
      .delete(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/products/${productId}`)
      .then((response) => {
        setCartItems((prevItems) =>
          prevItems.filter((item) => item.id !== productId)
        );
        setNotification({ message:"Product removed from cart!" , type:'success'});
        setTimeout(() => setNotification(null), 3000);
      })
      .catch((error) => {
        console.error("Error removing product from cart:", error);
      });
    }
    else{
      const updated_guest_product = guest_product.filter(item => item.id !== productId);
      localStorage.setItem("guest_products", JSON.stringify(updated_guest_product));
      setNotification({ message:"Product removed from cart!" , type:'success'});
      setTimeout(() => setNotification(null), 3000);
      window.location.reload(false);
    }
  };
  const updateCartItemQuantity = (productId, newQuantity) => {
  setCartItems(prevItems => {
    return prevItems.map(item =>
      item.id === productId ? { ...item, quantity: newQuantity } : item
    );
  });
};

  
  const incrementQuantity = (index) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems[index].quantity++;
    setCartItems(updatedCartItems);
  };

  const decrementQuantity = (index) => {
    const updatedCartItems = [...cartItems];
    if (updatedCartItems[index].quantity > 1) {
      updatedCartItems[index].quantity--;
      setCartItems(updatedCartItems);
    }
  };


  // The displayed price already has shipping and GST folded in, so this works
  // backwards out of the total to show the breakdown. Crucially that is only
  // true for INR: convertPrice adds nothing to a USD price, so subtracting a
  // 40 rupee shipping fee and unwinding 18% GST from a dollar total invented
  // charges that were never applied and drove "Original Price" negative.
  const calculateTotalPrice = () => {
    const shippingFeePerItem = 40; // rupees, per item
    const gstRate = 0.18;
    const items = isLoggedIn ? cartItems : guest_product;

    const totalPrice = items.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );

    // A dollar price is the seller's price and nothing else: no shipping to
    // strip out, no GST to unwind.
    if (selectedCountry !== "INR") {
      // Dollars carry cents; rounding to whole units here made the summary
      // disagree with the line items and with what Stripe charges.
      const exact = Math.round(totalPrice * 100) / 100;
      return {
        totalPrice: exact,
        shippingFee: 0,
        originalPrice: exact,
        gst: 0,
      };
    }

    const priceBeforeShipping = totalPrice / (1 + gstRate);
    const shippingFee = items.reduce(
      (total, item) => total + item.quantity * shippingFeePerItem,
      0
    );

    return {
      totalPrice: Math.round(totalPrice),
      shippingFee: Math.round(shippingFee),
      originalPrice: Math.round(priceBeforeShipping - shippingFee),
      gst: Math.round(totalPrice - priceBeforeShipping),
    };
  };
  
  
 
  
  
  useEffect(() => {
    if (localStorage.getItem("token") !== "admin") {
      localStorage.getItem("user-token") !== null && setIsLoggedIn(true);
    }
   
  }, []);

  const addToWishlist = (product) => {
    const userProduct=product.seller_id.toString()===localStorage.getItem('user-token')
    if(userProduct){
      setNotification({ message:"You are the seller of the product" , type:"error"});
      setTimeout(() => setNotification(null), 3000);
    }else{
      axios
      .post(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/addwishlist`, product)
      .then((response) => {
        // console.log(response.data)
        setWishItems((prevItems) => [...prevItems, product]);
      })
      .catch((error) => {
        console.error("Error adding to wishlist:", error);
      });
    setNotification({ message:"Product added to wishlist" , type:"success"});
    setTimeout(() => setNotification(null), 3000);
    window.location.reload(false);
    }

  };

  const removeFromWishlist = (productId) => {
    axios
      .delete(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/wishlist/${productId}`)
      .then((response) => {
        setWishItems((prevItems) =>
          prevItems.filter((item) => item.id !== productId)
        );
      })
      .catch((error) => {
        console.error("Error removing product from wishlist:", error);
      });
  };

  const moveFromWishlistToCart = () => {
    selectedWishlistItems.forEach((productId) => {
      const product = wishItems.find((item) => item.product_id === productId);
      if (product) {
        addToCart(product,"wish");
        removeFromWishlist(product.id);
      }
    });
    setSelectedWishlistItems([]);
  };

  const handleCheckboxChange = (productId) => {
    if (selectedWishlistItems.includes(productId)) {
      setSelectedWishlistItems(
        selectedWishlistItems.filter((id) => id !== productId)
      );
    } else {
      setSelectedWishlistItems([...selectedWishlistItems, productId]);
    }
  };
  

  return (
    <CartContext.Provider
      value={{
       
        notification,
        setNotification,
        user,
        setUserData,
        cartItems,
        setCartItems,
        addToCart,
        removeFromCart,
        incrementQuantity,
        decrementQuantity,
        calculateTotalPrice,
        wishItems,
        addToWishlist,
        removeFromWishlist,
        moveFromWishlistToCart,
        selectedWishlistItems,
        handleCheckboxChange,
        shippingAddressData,
        setShippingAddressData,
        billingAddressData,
        setBillingAddressData,
        updateCartItemQuantity,
        guest_product,
        setGuest_product,
        isLoggedIn,
        setIsLoggedIn,
        setWishItems,
        selectedCountry,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export function useData() {
  return useContext(CartContext);
}



